var exports = {
  "R_": "heading__n2YdSJ",
  "nd": "panel__iqwvJ0",
  "wx": "header__FDFbr3",
  "b": "closeButton__ef2Uoz",
  "rf": "body__2uOH1H",
};

module.exports = exports;
